import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import Footer from '@/components/Footer';
import NavBar from '@/components/NavBar';
import SkipLink from '@/components/layout/SkipLink';

interface PublicLayoutProps {
  /** Scope page-owned styles without letting the page own the global shell. */
  pageClassName?: string;
  /** Keep layout spacing separate from each page's editorial content. */
  mainClassName?: string;
  /** Optional accessible name for the route's single reading landmark. */
  mainAriaLabelledBy?: string;
  /** Optional stable accessible name when page content has multiple heading states. */
  mainAriaLabel?: string;
  children?: ReactNode;
}

const PublicLayout = ({
  pageClassName = 'public-page',
  mainClassName = 'public-layout__main',
  mainAriaLabelledBy,
  mainAriaLabel,
  children,
}: PublicLayoutProps) => {
  return (
    <div className={`min-h-screen flex flex-col ${pageClassName}`.trim()}>
      <SkipLink />
      <NavBar />
      <main
        id="main-content"
        className={`${mainClassName} grow pt-24`.trim()}
        aria-labelledby={mainAriaLabelledBy}
        aria-label={mainAriaLabel}
        tabIndex={-1}
      >
        {children ?? <Outlet />}
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
